export default __webpack_public_path__ + "static/media/moon.08cc53b0.png";